import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DirectionService } from '../../direction.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DialogService } from 'src/app/dialog/dialog.service';

import { UsersService } from 'src/app/super-management/user/users.service';

import { FilesService } from "src/app/main-section/printing-table/file.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-processing-file',
  templateUrl: './processing-file.component.html',
  styleUrls: ['./processing-file.component.css'],
  host: {
    class: 'fill-screen-modal-phone'
  }
})
export class ProcessingFileComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;
  isLoading: boolean = false;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;

  printingService: string = "";
  file: any;
  fileType: string = '';
  language: string = 'he';

  programmArray1 = ['Illustrator', 'Photoshop', 'Indesign', 'AutoCAD'];
  programmArray2Old = ['Revit', 'Canva', 'PowerPoint'];
  programmArray2 = ['Revit', 'Canva', 'PowerPoint'];

  isClosed: boolean = false;

  constructor(
    private directionService: DirectionService,
    private authService: AuthService,
    private dialogService: DialogService,
    private usersService: UsersService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private filesSevice: FilesService,
    private translate: TranslateService,
  ) {
    this.file = data.file;
    this.printingService = data.service;
  }

  async ngOnInit() {
    this.isLoading = true;
    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    // get this.currentLanguage$ from directionService
    this.directionService.currentLanguage$.subscribe((lang) => {
      this.language = lang;
    });

    this.programmArray2.push(this.translate.instant('processing-file.no-programm'));
    this.getReducedFormat(this.file);

    this.isLoading = false;
  }

  closeProcessingFileDialog() {
    if (this.isClosed) {
      this.dialogService.onCloseProcessingFileDialog();
    } else {
      this.isClosed = true;
      setTimeout(() => {
        this.dialogService.onCloseProcessingFileDialog();
      }, 2700);
    }
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
  }

  getReducedFormat(file: any) {
    const type = this.file.fileName.split('.').pop().toLowerCase() ? this.file.fileName.split('.').pop().toLowerCase() : "unknown";
    if (type === 'pdf') {
      this.fileType = 'PDF';
    } else if (type === 'jpeg' || type === 'jpg') {
      this.fileType = 'JPEG';
    } else {
      this.fileType = type.toUpperCase();
    }
  }

  getVeryReducedFormat() {
    const type = this.file.fileName.split('.').pop().toLowerCase() ? this.file.fileName.split('.').pop().toLowerCase() : "unknown";
    if (type === 'pdf') {
      return 'PDF';
    } else if (type === 'jpeg' || type === 'jpg') {
      return 'JPEG';
    } else if (type === 'png') {
      return 'PNG';
    } else {
      return "Unknown";
    }
  }

  instructionsInWhatsappForProgramm(programm: string) {
    let programmText = programm;
    let fileTypeText = this.getVeryReducedFormat();
    if (!this.programmArray1.includes(programm) && !this.programmArray2Old.includes(programm)) {
      programmText = "Unknown";
    }
    const phoneNumber = '97233746962';
    const message = encodeURIComponent('Editing-Instructions-At-Eazix-' + this.printingService + "-" + fileTypeText + "-" + programmText);
    const url = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(url, '_blank');
  }

  // ===============
}
